<app-dpp-field-label [label]="file.idShort | translateOrFallback:(file.idShort ?? '')"></app-dpp-field-label>
<div class="file-input-row">
  <ix-input
    [formControl]="formControl"
    class="w-100"
    [id]="'field_' + file.idShort"
    [placeholder]="
      'dpp.generic_submodel_editor.file_path_placeholder' | translate
    "
    [helperText]="
      file.contentType
        ? ('dpp.generic_submodel_editor.file_content_type' | translate) +
          ': ' +
          file.contentType
        : ''
    "
  />
</div>
